import { TabPageContentWrapper } from 'src/components/SharedDetailsComponents';
import styled from 'styled-components';

export const TabPageContentWrapperStyled = styled(TabPageContentWrapper)`
  max-width: 100%;
  overflow: hidden;
  word-break: break-all;
`;

export const FileUploadWrapper = styled.div`
  max-width: 100%;
  overflow: hidden;
  word-break: break-all;
`;
